// ChangeThicknessDialog.tsx — Override panel thickness (chvar)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import type { ChVar } from '../types/panelvar';

export default function ChangeThicknessDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [ch, setCh] = useState<ChVar>(panel ? { ...panel.chvar } : { top: 0.75, bottom: 0.75, left: 0.75, right: 0.75, reveal: 0 });
  if (!panel) return null;

  function set(key: keyof ChVar, value: number) {
    setCh(prev => ({ ...prev, [key]: value }));
  }

  return (
    <DialogBase title="Change Thickness" onOk={() => updatePanel(panel.id, { chvar: ch })}>
      <div className="dialog-section">
        {(['top', 'bottom', 'left', 'right', 'reveal'] as (keyof ChVar)[]).map(key => (
          <div className="dialog-row" key={key}>
            <label className="dialog-label">{String(key)}</label>
            <input
              className="dialog-input sm"
              type="number"
              value={ch[key]}
              step={0.25}
              onChange={e => set(key, parseFloat(e.target.value))}
            />
            <span className="dialog-unit">"</span>
          </div>
        ))}
      </div>
    </DialogBase>
  );
}
